export default __webpack_public_path__ + "static/media/locked.abfd1c05.svg";